import api from './api/api'

export const findAllTipoDocumentosGeomensor = async () => {
  return api().get(`/publico/tipoDocumentoCredenciado/findAllGeomensor`)
}

export const findAllTipoDocumentosVistoriador = async () => {
  return api().get(`/publico/tipoDocumentoCredenciado/findAllVistoriador`)
}
